/** Location fields (clients, seminar venues) <-> API values (pure). */

export const DEFAULT_RADIUS = 200;

const isBlank = (v) => v === "" || v === null || v === undefined;

/** Returns what is wrong with the fields, or "" when they can be saved. */
export const locationProblem = (
  { latitude, longitude, geofenceRadius },
  { minRadius = 10, maxRadius = 50000 } = {},
) => {
  if (isBlank(latitude) !== isBlank(longitude))
    return "Enter both latitude and longitude, or leave both empty.";
  if (!isBlank(latitude)) {
    const lat = Number(latitude);
    if (!Number.isFinite(lat) || lat < -90 || lat > 90)
      return "Latitude must be between -90 and 90.";
    const lng = Number(longitude);
    if (!Number.isFinite(lng) || lng < -180 || lng > 180)
      return "Longitude must be between -180 and 180.";
  }
  if (!isBlank(geofenceRadius)) {
    const r = Number(geofenceRadius);
    if (!Number.isInteger(r) || r < minRadius || r > maxRadius)
      return `Radius must be a whole number from ${minRadius.toLocaleString("en-US")} to ${maxRadius.toLocaleString("en-US")} metres.`;
  }
  return "";
};

/** Empty fields are sent as null; the API uses 200 m when the radius is empty. */
export const locationPayload = ({ latitude, longitude, geofenceRadius }) => ({
  latitude: isBlank(latitude) ? null : Number(latitude),
  longitude: isBlank(longitude) ? null : Number(longitude),
  geofenceRadius: isBlank(geofenceRadius) ? null : Number(geofenceRadius),
});

/** Only http(s) links from the lookup become links. */
export const safeMapUrl = (url) =>
  /^https?:\/\//i.test(url || "") ? url : null;
